import React, { useState, useEffect, useContext, Fragment } from "react";
import { AppContext } from "../Utils/AppContext";
import UserForm from "../Forms/UserForm";
import Page from "../Layout/Page";
import UserTable from "../Tables/UserTable";

const Users = () => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  const [showUserForm, setShowUserForm] = useState(false);

  return (
    <Page title="Managers">
      {currentUser.role === "super" && <UserTable hideEnergy userRole="managers" />}

      {currentUser.role === "company-manager" && (
        <UserTable hideEnergy hideCompany companyId={currentUser.company.id} />
      )}

      {currentUser.role === "fleet-manager" && (
        <UserTable hideEnergy hideCompany companyId={currentUser.company.id} userRole="driver" />
      )}

      {showUserForm && (
        <Fragment>
          <br />
          <UserForm
            cid={currentUser.role !== "super" && currentUser.company.id}
            formComplete={() => {
              setShowUserForm(false);
            }}
          />

          <button
            type="button"
            onClick={() => {
              setShowUserForm(false);
            }}
          >
            Cancel
          </button>
        </Fragment>
      )}

      {!showUserForm && (
        <Fragment>
          <button
            type="button"
            onClick={() => {
              setShowUserForm(true);
            }}
          >
            Add User
          </button>
        </Fragment>
      )}
    </Page>
  );
};

export default Users;
